import React from "react";
import useWindowSize from "../../../../hooks/useWindowSize";
import { func } from "../../../../utils";

const KnockoutTable = (knockoutData) => {
  const isSMP = knockoutData?.data?.category === "futsalSMP";

  // Extract all "round_name" values and remove duplicates
  // const roundNames = [
  //   ...new Set(knockoutData?.data?.flat().map((round) => round.round_name)),
  // ];

  const match = knockoutData?.data;

  const dataRoundOf16 = match?.rounds
    ? match?.rounds?.flatMap((round) =>
        round.filter((match) => match.round_name === "Round Of 16")
      )
    : [];

  const dataQuarterFinals = match?.rounds
    ? match?.rounds?.flatMap((round) =>
        round.filter((match) => match.round_name === "Quarterfinal")
      )
    : [];

  const dataSemiFinals = match?.rounds
    ? match?.rounds?.flatMap((round) =>
        round.filter((match) => match.round_name === "Semifinal")
      )
    : [];

  const dataFinals = match?.rounds
    ? match?.rounds?.flatMap((round) =>
        round.filter((match) => match.round_name === "Final")
      )
    : [];

  const dataThirdPlace = match?.rounds
    ? match?.rounds?.flatMap((round) =>
        round.filter((match) => match.round_name === "Third Place")
      )
    : [];

  const { size } = useWindowSize();
  const isMobileView = (size?.width || 0) <= 830;

  const EmptyTeamCapsule = ({ text, hasBack = false, hasFront = true }) => {
    return (
      <div className="flex">
        {hasBack && (
          <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
        )}
        <div
          className={`flex items-center justify-between w-[172px] md:w-[196px] h-[42px] bg-[#006E8D] rounded-full`}
        >
          <span
            className={`pl-4 capitalize pr-0 py-2 text-[14px]/[15px] text-white block whitespace-normal overflow-wrap break-word`}
          >
            {text}
          </span>
        </div>
        {hasFront && (
          <div className="relative self-center w-[14px] h-[2px] bg-[#23556d]"></div>
        )}
      </div>
    );
  };

  const TeamCapsule = ({
    club,
    secondClub,
    hasBack = false,
    hasFront = true,
  }) => {
    const hasPlayed = club?.winner || secondClub?.winner;
    const isScored =
      club?.score === 0 &&
      secondClub?.score === 0 &&
      club.penalty_score === 0 &&
      secondClub.penalty_score === 0;

    return (
      <div className="flex">
        {hasBack && (
          <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
        )}
        <div
          className={`flex items-center justify-between w-[172px] md:w-[196px] h-[42px] ${
            !hasPlayed
              ? "bg-[#006E8D]"
              : club?.winner
              ? "bg-[#e0f6fe]"
              : "bg-[#4593b4]"
          } rounded-full`}
        >
          <span
            className={`font-bold pl-4 pr-0 py-2 text-[13px]/[15px] md:text-[14px]/[15px] ${
              !hasPlayed
                ? "text-white"
                : club?.winner
                ? "text-[#222d3c]"
                : "text-[#d5e9f0]"
            } block whitespace-normal overflow-wrap break-word capitalize`}
          >
            {club?.name}
          </span>

          {club?.score !== undefined && (
            <div
              className={`relative h-[100%] w-[49px] text-center font-bold flex items-center justify-center ${
                !hasPlayed
                  ? "bg-white"
                  : club?.winner
                  ? "bg-[#222d3c]"
                  : "bg-[#d5e9f0]"
              } ${
                !hasPlayed
                  ? "text-[#00BCF1]"
                  : club?.winner
                  ? "text-white"
                  : "text-[#6c7480]"
              } rounded-full flex-shrink-0`}
            >
              {club?.winner_penalty ? (
                <img
                  src={func.getStaticImg(`icon/notes-red.svg`)}
                  alt="notes"
                  className="absolute right-0 top-0"
                />
              ) : null}
              {secondClub?.name ? (
                <>
                  <span>
                    {secondClub.score !== undefined ? club?.score : "-"}
                  </span>
                  {hasPlayed &&
                    club?.score === secondClub?.score &&
                    club?.penalty_score !== secondClub?.penalty_score && (
                      <span className="ml-1">{`(${club?.penalty_score})`}</span>
                    )}
                </>
              ) : (
                <span>{"-"}</span>
              )}
            </div>
          )}
        </div>
        {hasFront && (
          <div className="relative self-center w-[14px] h-[2px] bg-[#23556d]"></div>
        )}
      </div>
    );
  };

  const RoundOf16 = ({ dataRoundOf16 }) => {
    console.log({ dataRoundOf16, aaa: dataRoundOf16[1]?.home_club });
    return (
      <div className="flex flex-col gap-14">
        {dataRoundOf16[0] ? (
          <div className="flex">
            <div className="flex flex-col gap-6">
              {dataRoundOf16[0]?.club1 || dataRoundOf16[0]?.home_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[0]?.club1 || dataRoundOf16[0]?.home_club}
                  secondClub={
                    dataRoundOf16[0]?.club2 || dataRoundOf16[0]?.away_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 1"} />
              )}
              {dataRoundOf16[0]?.club2 || dataRoundOf16[0]?.away_club ? (
                <TeamCapsule
                  club={dataRoundOf16[0]?.club2 || dataRoundOf16[0]?.away_club}
                  secondClub={
                    dataRoundOf16[0]?.club1 || dataRoundOf16[0]?.home_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 2"} />
              )}
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        ) : (
          <div className="flex">
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"Team 1"} />
              <EmptyTeamCapsule text={"Team 2"} />
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        )}

        {dataRoundOf16[1] ? (
          <div className="flex">
            <div className="flex flex-col gap-6">
              {dataRoundOf16[1]?.club1 || dataRoundOf16[1]?.home_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[1]?.club1 || dataRoundOf16[1]?.home_club}
                  secondClub={
                    dataRoundOf16[1]?.club2 || dataRoundOf16[1]?.away_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 3"} />
              )}
              {dataRoundOf16[1]?.club2 || dataRoundOf16[1]?.away_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[1]?.club2 || dataRoundOf16[1]?.away_club}
                  secondClub={
                    dataRoundOf16[1]?.club1 || dataRoundOf16[1]?.home_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 4"} />
              )}
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        ) : (
          <div className="flex">
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"Team 3"} />
              <EmptyTeamCapsule text={"Team 4"} />
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        )}

        {dataRoundOf16[2] ? (
          <div className="flex">
            <div className="flex flex-col gap-6">
              {dataRoundOf16[2]?.club1 || dataRoundOf16[2]?.home_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[2]?.club1 || dataRoundOf16[2]?.home_club}
                  secondClub={
                    dataRoundOf16[2]?.club2 || dataRoundOf16[2]?.away_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 5"} />
              )}
              {dataRoundOf16[2]?.club2 || dataRoundOf16[2]?.away_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[2]?.club2 || dataRoundOf16[2]?.away_club}
                  secondClub={
                    dataRoundOf16[2]?.club1 || dataRoundOf16[2]?.home_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 6"} />
              )}
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        ) : (
          <div className="flex">
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"Team 5"} />
              <EmptyTeamCapsule text={"Team 6"} />
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        )}

        {dataRoundOf16[3] ? (
          <div className="flex">
            <div className="flex flex-col gap-6">
              {dataRoundOf16[3]?.club1 || dataRoundOf16[3]?.home_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[3]?.club1 || dataRoundOf16[3]?.home_club}
                  secondClub={
                    dataRoundOf16[3]?.club2 || dataRoundOf16[3]?.away_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 7"} />
              )}
              {dataRoundOf16[3]?.club2 || dataRoundOf16[3]?.away_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[3]?.club2 || dataRoundOf16[3]?.away_club}
                  secondClub={
                    dataRoundOf16[3]?.club1 || dataRoundOf16[3]?.home_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 8"} />
              )}
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        ) : (
          <div className="flex">
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"Team 7"} />
              <EmptyTeamCapsule text={"Team 8"} />
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        )}

        {dataRoundOf16[4] ? (
          <div className="flex">
            <div className="flex flex-col gap-6">
              {dataRoundOf16[4]?.club1 || dataRoundOf16[4]?.home_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[4]?.club1 || dataRoundOf16[4]?.home_club}
                  secondClub={
                    dataRoundOf16[4]?.club2 || dataRoundOf16[4]?.away_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 9"} />
              )}
              {dataRoundOf16[4]?.club2 || dataRoundOf16[4]?.away_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[4]?.club2 || dataRoundOf16[4]?.away_club}
                  secondClub={
                    dataRoundOf16[4]?.club1 || dataRoundOf16[4]?.home_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 10"} />
              )}
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        ) : (
          <div className="flex">
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"Team 9"} />
              <EmptyTeamCapsule text={"Team 10"} />
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        )}

        {dataRoundOf16[5] ? (
          <div className="flex">
            <div className="flex flex-col gap-6">
              {dataRoundOf16[5]?.club1 || dataRoundOf16[5]?.home_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[5]?.club1 || dataRoundOf16[5]?.home_club}
                  secondClub={
                    dataRoundOf16[5]?.club2 || dataRoundOf16[5]?.away_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 11"} />
              )}
              {dataRoundOf16[5]?.club2 || dataRoundOf16[5]?.away_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[5]?.club2 || dataRoundOf16[5]?.away_club}
                  secondClub={
                    dataRoundOf16[5]?.club1 || dataRoundOf16[5]?.home_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 12"} />
              )}
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        ) : (
          <div className="flex">
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"Team 11"} />
              <EmptyTeamCapsule text={"Team 12"} />
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        )}

        {dataRoundOf16[6] ? (
          <div className="flex">
            <div className="flex flex-col gap-6">
              {dataRoundOf16[6]?.club1 || dataRoundOf16[6]?.home_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[6]?.club1 || dataRoundOf16[6]?.home_club}
                  secondClub={
                    dataRoundOf16[6]?.club2 || dataRoundOf16[6]?.away_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 13"} />
              )}
              {dataRoundOf16[6]?.club2 || dataRoundOf16[6]?.away_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[6]?.club2 || dataRoundOf16[6]?.away_club}
                  secondClub={
                    dataRoundOf16[6]?.club1 || dataRoundOf16[6]?.home_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 14"} />
              )}
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        ) : (
          <div className="flex">
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"Team 13"} />
              <EmptyTeamCapsule text={"Team 14"} />
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        )}

        {dataRoundOf16[7] ? (
          <div className="flex">
            <div className="flex flex-col gap-6">
              {dataRoundOf16[7]?.club1 || dataRoundOf16[7]?.home_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[7]?.club1 || dataRoundOf16[7]?.home_club}
                  secondClub={
                    dataRoundOf16[7]?.club2 || dataRoundOf16[7]?.away_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 15"} />
              )}
              {dataRoundOf16[7]?.club2 || dataRoundOf16[7]?.away_club?.id ? (
                <TeamCapsule
                  club={dataRoundOf16[7]?.club2 || dataRoundOf16[7]?.away_club}
                  secondClub={
                    dataRoundOf16[7]?.club1 || dataRoundOf16[7]?.home_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Team 16"} />
              )}
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        ) : (
          <div className="flex">
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"Team 15"} />
              <EmptyTeamCapsule text={"Team 16"} />
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        )}
      </div>
    );
  };

  const QuarterFinals = ({ dataQuarterFinals, isSMP }) => {
    return (
      <div className="flex flex-col gap-14">
        {dataQuarterFinals[0] ? (
          <div className="flex">
            <div className="flex flex-col gap-6">
              {dataQuarterFinals[0]?.club1 ||
              dataQuarterFinals[0]?.home_club ? (
                <TeamCapsule
                  club={
                    dataQuarterFinals[0]?.club1 ||
                    dataQuarterFinals[0]?.home_club
                  }
                  secondClub={
                    dataQuarterFinals[0]?.club2 ||
                    dataQuarterFinals[0]?.away_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Posisi 1"} />
              )}
              {dataQuarterFinals[0]?.club2 ||
              dataQuarterFinals[0]?.away_club ? (
                <TeamCapsule
                  club={
                    dataQuarterFinals[0]?.club2 ||
                    dataQuarterFinals[0]?.away_club
                  }
                  secondClub={
                    dataQuarterFinals[0]?.club1 ||
                    dataQuarterFinals[0]?.home_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Posisi 8"} />
              )}
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        ) : (
          <div className="flex">
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"Posisi 1"} />
              <EmptyTeamCapsule text={"Posisi 8"} />
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        )}

        {dataQuarterFinals[1] ? (
          <div className="flex">
            <div className="flex flex-col gap-6">
              {dataQuarterFinals[1]?.club1 ||
              dataQuarterFinals[1]?.home_club ? (
                <TeamCapsule
                  club={
                    dataQuarterFinals[1]?.club1 ||
                    dataQuarterFinals[1]?.home_club
                  }
                  secondClub={
                    dataQuarterFinals[1]?.club2 ||
                    dataQuarterFinals[1]?.away_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Posisi 2"} />
              )}
              {dataQuarterFinals[1]?.club2 ||
              dataQuarterFinals[1]?.away_club ? (
                <TeamCapsule
                  club={
                    dataQuarterFinals[1]?.club2 ||
                    dataQuarterFinals[1]?.away_club
                  }
                  secondClub={
                    dataQuarterFinals[1]?.club1 ||
                    dataQuarterFinals[1]?.home_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Posisi 7"} />
              )}
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        ) : (
          <div className="flex">
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"Posisi 2"} />
              <EmptyTeamCapsule text={"Posisi 7"} />
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        )}

        {dataQuarterFinals[2] ? (
          <div className="flex">
            <div className="flex flex-col gap-6">
              {dataQuarterFinals[2]?.club1 ||
              dataQuarterFinals[2]?.home_club ? (
                <TeamCapsule
                  club={
                    dataQuarterFinals[2]?.club1 ||
                    dataQuarterFinals[2]?.home_club
                  }
                  secondClub={
                    dataQuarterFinals[2]?.club2 ||
                    dataQuarterFinals[2]?.away_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Posisi 3"} />
              )}
              {dataQuarterFinals[2]?.club2 ||
              dataQuarterFinals[2]?.away_club ? (
                <TeamCapsule
                  club={
                    dataQuarterFinals[2]?.club2 ||
                    dataQuarterFinals[2]?.away_club
                  }
                  secondClub={
                    dataQuarterFinals[2]?.club1 ||
                    dataQuarterFinals[2]?.home_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Posisi 6"} />
              )}
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        ) : (
          <div className="flex">
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"Posisi 3"} />
              <EmptyTeamCapsule text={"Posisi 6"} />
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        )}

        {dataQuarterFinals[3] ? (
          <div className="flex">
            <div className="flex flex-col gap-6">
              {dataQuarterFinals[3]?.club1 ||
              dataQuarterFinals[3]?.home_club ? (
                <TeamCapsule
                  club={
                    dataQuarterFinals[3]?.club1 ||
                    dataQuarterFinals[3]?.home_club
                  }
                  secondClub={
                    dataQuarterFinals[3]?.club2 ||
                    dataQuarterFinals[3]?.away_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Posisi 4"} />
              )}
              {dataQuarterFinals[3]?.club2 ||
              dataQuarterFinals[3]?.away_club ? (
                <TeamCapsule
                  club={
                    dataQuarterFinals[3]?.club2 ||
                    dataQuarterFinals[3]?.away_club
                  }
                  secondClub={
                    dataQuarterFinals[3]?.club1 ||
                    dataQuarterFinals[3]?.home_club
                  }
                />
              ) : (
                <EmptyTeamCapsule text={"Posisi 5"} />
              )}
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        ) : (
          <div className="flex">
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"Posisi 4"} />
              <EmptyTeamCapsule text={"Posisi 5"} />
            </div>
            <div
              className={`relative self-center h-[59px] w-1 bg-[#23556d]`}
            ></div>
          </div>
        )}
      </div>
    );
  };

  const SemiFinals = ({ dataSemiFinals, isSMP, overrideRule }) => {
    if (overrideRule) {
      return (
        <div className="flex flex-col self-center gap-[22.2rem]">
          <div className="flex">
            <div className="flex flex-col gap-36">
              {dataSemiFinals[0]?.home_club?.id &&
              dataSemiFinals[0]?.away_club?.id ? (
                <TeamCapsule
                  club={dataSemiFinals[0]?.home_club}
                  secondClub={dataSemiFinals[0]?.away_club}
                  hasBack={true}
                  hasFront={true}
                />
              ) : (
                <EmptyTeamCapsule
                  text={"Semifinalis 1"}
                  hasBack={true}
                  hasFront={true}
                />
              )}
            </div>
          </div>

          <div className="flex">
            <div className="flex flex-col gap-36">
              {dataSemiFinals[0]?.away_club?.id ? (
                <TeamCapsule
                  club={dataSemiFinals[0]?.away_club}
                  secondClub={dataSemiFinals[0]?.away_club}
                  hasBack={true}
                  hasFront={true}
                />
              ) : (
                <EmptyTeamCapsule
                  text={"Semifinalis 2"}
                  hasBack={true}
                  hasFront={true}
                />
              )}
            </div>
          </div>

          <div className="flex">
            <div className="flex flex-col gap-36">
              {dataSemiFinals[1]?.home_club?.id &&
              dataSemiFinals[1]?.away_club?.id ? (
                <TeamCapsule
                  club={dataSemiFinals[1]?.home_club}
                  secondClub={dataSemiFinals[1]?.away_club}
                  hasBack={true}
                  hasFront={true}
                />
              ) : (
                <EmptyTeamCapsule
                  text={"Semifinalis 3"}
                  hasBack={true}
                  hasFront={true}
                />
              )}
            </div>
          </div>

          <div className="flex">
            <div className="flex flex-col gap-36">
              {dataSemiFinals[1]?.away_club?.id ? (
                <TeamCapsule
                  club={dataSemiFinals[1]?.away_club}
                  secondClub={dataSemiFinals[1]?.away_club}
                  hasBack={true}
                  hasFront={true}
                />
              ) : (
                <EmptyTeamCapsule
                  text={"Semifinalis 4"}
                  hasBack={true}
                  hasFront={true}
                />
              )}
            </div>
          </div>
        </div>
      );
    } else if (isSMP) {
      return (
        <div className="flex flex-col self-center gap-36">
          {dataSemiFinals[0] ? (
            <div className="flex">
              <div className="flex flex-col gap-36">
                {dataSemiFinals[0]?.club1 ||
                dataSemiFinals[0]?.home_club?.id ? (
                  <TeamCapsule
                    club={
                      dataSemiFinals[0]?.club1 || dataSemiFinals[0]?.home_club
                    }
                    secondClub={
                      dataSemiFinals[0]?.club2 || dataSemiFinals[0]?.away_club
                    }
                    hasBack={true}
                    // style={{ position: "relative", top: "-80px" }}
                  />
                ) : (
                  <EmptyTeamCapsule text={"Quarter-finalis 1"} hasBack={true} />
                )}
                {dataSemiFinals[0]?.club2 ||
                dataSemiFinals[0]?.away_club?.id ? (
                  <TeamCapsule
                    club={
                      dataSemiFinals[0]?.club2 || dataSemiFinals[0]?.away_club
                    }
                    secondClub={
                      dataSemiFinals[0]?.club1 || dataSemiFinals[0]?.home_club
                    }
                    hasBack={true}
                  />
                ) : (
                  <EmptyTeamCapsule text={"Quarter-finalis 2"} hasBack={true} />
                )}
              </div>
              <div
                className={`relative self-center h-[134px] w-1 bg-[#23556d]`}
              ></div>

              <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
            </div>
          ) : (
            <div className="flex">
              <div className="flex flex-col gap-36">
                <EmptyTeamCapsule text={"Quarter-finalis 1"} hasBack={true} />
                <EmptyTeamCapsule text={"Quarter-finalis 2"} hasBack={true} />
              </div>
              <div
                className={`relative self-center h-[134px] w-1 bg-[#23556d]`}
              ></div>
              <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
            </div>
          )}

          {dataSemiFinals[1] ? (
            <div className="flex">
              <div className="flex flex-col gap-36">
                {dataSemiFinals[1]?.club1 ||
                dataSemiFinals[1]?.home_club?.id ? (
                  <TeamCapsule
                    club={
                      dataSemiFinals[1]?.club1 || dataSemiFinals[1]?.home_club
                    }
                    secondClub={
                      dataSemiFinals[1]?.club2 || dataSemiFinals[1]?.away_club
                    }
                    hasBack={true}
                  />
                ) : (
                  <EmptyTeamCapsule text={"Quarter-finalis 3"} hasBack={true} />
                )}
                {dataSemiFinals[1]?.club2 ||
                dataSemiFinals[1]?.away_club?.id ? (
                  <TeamCapsule
                    club={
                      dataSemiFinals[1]?.club2 || dataSemiFinals[1]?.away_club
                    }
                    secondClub={
                      dataSemiFinals[1]?.club1 || dataSemiFinals[1]?.home_club
                    }
                    hasBack={true}
                  />
                ) : (
                  <EmptyTeamCapsule text={"Quarter-finalis 4"} hasBack={true} />
                )}
              </div>
              <div
                className={`relative self-center h-[134px] w-1 bg-[#23556d]`}
              ></div>
              <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
            </div>
          ) : (
            <div className="flex">
              <div className="flex flex-col gap-36">
                <EmptyTeamCapsule text={"Quarter-finalis 3"} hasBack={true} />
                <EmptyTeamCapsule text={"Quarter-finalis 4"} hasBack={true} />
              </div>
              <div
                className={`relative self-center h-[134px] w-1 bg-[#23556d]`}
              ></div>
              <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
            </div>
          )}

          {dataSemiFinals[2] ? (
            <div className="flex">
              <div className="flex flex-col gap-36">
                {dataSemiFinals[2]?.club1 ||
                dataSemiFinals[2]?.home_club?.id ? (
                  <TeamCapsule
                    club={
                      dataSemiFinals[2]?.club1 || dataSemiFinals[2]?.home_club
                    }
                    secondClub={
                      dataSemiFinals[2]?.club2 || dataSemiFinals[2]?.away_club
                    }
                    hasBack={true}
                  />
                ) : (
                  <EmptyTeamCapsule text={"Quarter-finalis 3"} hasBack={true} />
                )}
                {dataSemiFinals[2]?.club2 ||
                dataSemiFinals[2]?.away_club?.id ? (
                  <TeamCapsule
                    club={
                      dataSemiFinals[2]?.club2 || dataSemiFinals[2]?.away_club
                    }
                    secondClub={
                      dataSemiFinals[2]?.club1 || dataSemiFinals[2]?.home_club
                    }
                    hasBack={true}
                  />
                ) : (
                  <EmptyTeamCapsule text={"Quarter-finalis 4"} hasBack={true} />
                )}
              </div>
              <div
                className={`relative self-center h-[134px] w-1 bg-[#23556d]`}
              ></div>
              <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
            </div>
          ) : (
            <div className="flex">
              <div className="flex flex-col gap-36">
                <EmptyTeamCapsule text={"Quarter-finalis 3"} hasBack={true} />
                <EmptyTeamCapsule text={"Quarter-finalis 4"} hasBack={true} />
              </div>
              <div
                className={`relative self-center h-[134px] w-1 bg-[#23556d]`}
              ></div>
              <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
            </div>
          )}

          {dataSemiFinals[3] ? (
            <div className="flex">
              <div className="flex flex-col gap-36">
                {dataSemiFinals[3]?.club1 ||
                dataSemiFinals[3]?.home_club?.id ? (
                  <TeamCapsule
                    club={
                      dataSemiFinals[3]?.club1 || dataSemiFinals[3]?.home_club
                    }
                    secondClub={
                      dataSemiFinals[3]?.club2 || dataSemiFinals[3]?.away_club
                    }
                    hasBack={true}
                  />
                ) : (
                  <EmptyTeamCapsule text={"Quarter-finalis 3"} hasBack={true} />
                )}
                {dataSemiFinals[3]?.club2 ||
                dataSemiFinals[3]?.away_club?.id ? (
                  <TeamCapsule
                    club={
                      dataSemiFinals[3]?.club2 || dataSemiFinals[3]?.away_club
                    }
                    secondClub={
                      dataSemiFinals[3]?.club1 || dataSemiFinals[3]?.home_club
                    }
                    hasBack={true}
                  />
                ) : (
                  <EmptyTeamCapsule text={"Quarter-finalis 4"} hasBack={true} />
                )}
              </div>
              <div
                className={`relative self-center h-[134px] w-1 bg-[#23556d]`}
              ></div>
              <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
            </div>
          ) : (
            <div className="flex">
              <div className="flex flex-col gap-36">
                <EmptyTeamCapsule text={"Quarter-finalis 3"} hasBack={true} />
                <EmptyTeamCapsule text={"Quarter-finalis 4"} hasBack={true} />
              </div>
              <div
                className={`relative self-center h-[134px] w-1 bg-[#23556d]`}
              ></div>
              <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
            </div>
          )}
        </div>
      );
    } else
      return (
        <div className="flex flex-col self-center gap-36">
          {dataSemiFinals[0] ? (
            <div className="flex">
              <div className="flex flex-col gap-36">
                {dataSemiFinals[0]?.club1 ||
                dataSemiFinals[0]?.home_club?.id ? (
                  <TeamCapsule
                    club={
                      dataSemiFinals[0]?.club1 || dataSemiFinals[0]?.home_club
                    }
                    secondClub={
                      dataSemiFinals[0]?.club2 || dataSemiFinals[0]?.away_club
                    }
                    hasBack={true}
                    // style={{ position: "relative", top: "-80px" }}
                  />
                ) : (
                  <EmptyTeamCapsule text={"Semifinalis 1"} hasBack={true} />
                )}
                {dataSemiFinals[0]?.club2 ||
                dataSemiFinals[0]?.away_club?.id ? (
                  <TeamCapsule
                    club={
                      dataSemiFinals[0]?.club2 || dataSemiFinals[0]?.away_club
                    }
                    secondClub={
                      dataSemiFinals[0]?.club1 || dataSemiFinals[0]?.home_club
                    }
                    hasBack={true}
                  />
                ) : (
                  <EmptyTeamCapsule text={"Semifinalis 2"} hasBack={true} />
                )}
              </div>
              <div
                className={`relative self-center h-[134px] w-1 bg-[#23556d]`}
              ></div>
              <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
            </div>
          ) : (
            <div className="flex">
              <div className="flex flex-col gap-36">
                <EmptyTeamCapsule text={"Semifinalis 1"} hasBack={true} />
                <EmptyTeamCapsule text={"Semifinalis 2"} hasBack={true} />
              </div>
              <div
                className={`relative self-center h-[134px] w-1 bg-[#23556d]`}
              ></div>
              <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
            </div>
          )}

          {dataSemiFinals[1] ? (
            <div className="flex">
              <div className="flex flex-col gap-36">
                {dataSemiFinals[1]?.club1 ||
                dataSemiFinals[1]?.home_club?.id ? (
                  <TeamCapsule
                    club={
                      dataSemiFinals[1]?.club1 || dataSemiFinals[1]?.home_club
                    }
                    secondClub={
                      dataSemiFinals[1]?.club2 || dataSemiFinals[1]?.away_club
                    }
                    hasBack={true}
                  />
                ) : (
                  <EmptyTeamCapsule text={"Semifinalis 3"} hasBack={true} />
                )}
                {dataSemiFinals[1]?.club2 ||
                dataSemiFinals[1]?.away_club?.id ? (
                  <TeamCapsule
                    club={
                      dataSemiFinals[1]?.club2 || dataSemiFinals[1]?.away_club
                    }
                    secondClub={
                      dataSemiFinals[1]?.club1 || dataSemiFinals[1]?.home_club
                    }
                    hasBack={true}
                  />
                ) : (
                  <EmptyTeamCapsule text={"Semifinalis 4"} hasBack={true} />
                )}
              </div>
              <div
                className={`relative self-center h-[134px] w-1 bg-[#23556d]`}
              ></div>
              <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
            </div>
          ) : (
            <div className="flex">
              <div className="flex flex-col gap-36">
                <EmptyTeamCapsule text={"Semifinalis 3"} hasBack={true} />
                <EmptyTeamCapsule text={"Semifinalis 4"} hasBack={true} />
              </div>
              <div
                className={`relative self-center h-[134px] w-1 bg-[#23556d]`}
              ></div>
              <div className="relative self-center w-[18px] h-[2px] bg-[#23556d]"></div>
            </div>
          )}
        </div>
      );
  };

  const Finals = ({ dataFinals }) => {
    return (
      <div className="border-solid border-2 border-[#34CEF9] p-4 rounded-3xl">
        <h2 className="text-center text-white mb-2">Final</h2>
        <div className="flex flex-col gap-14 ">
          {dataFinals[0] ? (
            <div className="flex flex-col gap-6">
              {dataFinals[0]?.club1 || dataFinals[0]?.home_club?.id ? (
                <TeamCapsule
                  club={dataFinals[0]?.club1 || dataFinals[0]?.home_club}
                  secondClub={dataFinals[0]?.club2 || dataFinals[0]?.away_club}
                  hasFront={false}
                />
              ) : (
                <EmptyTeamCapsule text={"Finalis 1"} hasFront={false} />
              )}
              {dataFinals[0]?.club2 || dataFinals[0]?.away_club?.id ? (
                <TeamCapsule
                  club={dataFinals[0]?.club2 || dataFinals[0]?.away_club}
                  secondClub={dataFinals[0]?.club1 || dataFinals[0]?.home_club}
                  hasFront={false}
                />
              ) : (
                <EmptyTeamCapsule text={"Finalis 2"} hasFront={false} />
              )}
            </div>
          ) : (
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"Finalis 1"} hasFront={false} />
              <EmptyTeamCapsule text={"Finalis 2"} hasFront={false} />
            </div>
          )}
        </div>
      </div>
    );
  };

  const ThirdPlace = ({ dataThirdPlace }) => {
    return (
      <div className="border-solid border-2 border-[#34CEF9] p-4 rounded-3xl">
        <h2 className="text-center text-white mb-2">3rd Place</h2>
        <div className="flex flex-col gap-14 ">
          {dataThirdPlace[0] ? (
            <div className="flex flex-col gap-6">
              {dataThirdPlace[0]?.club1 || dataThirdPlace[0]?.home_club ? (
                <TeamCapsule
                  club={
                    dataThirdPlace[0]?.club1 || dataThirdPlace[0]?.home_club
                  }
                  secondClub={
                    dataThirdPlace[0]?.club2 || dataThirdPlace[0]?.away_club
                  }
                  hasFront={false}
                />
              ) : (
                <EmptyTeamCapsule text={"3rd Finalis 1"} hasFront={false} />
              )}
              {dataThirdPlace[0]?.club2 || dataThirdPlace[0]?.away_club ? (
                <TeamCapsule
                  club={
                    dataThirdPlace[0]?.club2 || dataThirdPlace[0]?.away_club
                  }
                  secondClub={
                    dataThirdPlace[0]?.club1 || dataThirdPlace[0]?.home_club
                  }
                  hasFront={false}
                />
              ) : (
                <EmptyTeamCapsule text={"3rd Finalis 2"} hasFront={false} />
              )}
            </div>
          ) : (
            <div className="flex flex-col gap-6">
              <EmptyTeamCapsule text={"3rd Finalis 1"} hasFront={false} />
              <EmptyTeamCapsule text={"3rd Finalis 2"} hasFront={false} />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="flex items-center overflow-x-auto md:overflow-x-visible md:overflow-y-visible whitespace-nowrap">
      <div className="flex items-start py-7 md:pr-[20rem] flex-row rounded-3xl">
        {isSMP ? (
          <>
            <RoundOf16 dataRoundOf16={dataRoundOf16} />
            {/* quarter final */}
            <SemiFinals dataSemiFinals={dataQuarterFinals} isSMP={true} />
            {/* <QuarterFinals dataQuarterFinals={dataQuarterFinals} isSMP={true} /> */}
            <SemiFinals
              dataSemiFinals={dataSemiFinals}
              isSMP={true}
              overrideRule={true}
            />
            <div className={`relative self-center h-[795px] w-1 bg-[#23556d]`}>
              <div
                className={`relative self-center h-[2px] w-[105px] bg-[#23556d] top-[397.5px]`}
              ></div>
            </div>

            <div className="flex flex-col gap-6 relative self-center left-[100px]">
              <div className="flex center">
                <Finals dataFinals={dataFinals} />
              </div>
              {/* <div className="flex center">
                <div className=" self-center w-[18px] h-[2px] bg-transparent"></div>
                <ThirdPlace dataThirdPlace={dataThirdPlace} />
              </div> */}
            </div>
          </>
        ) : (
          <>
            <QuarterFinals dataQuarterFinals={dataQuarterFinals} />
            <SemiFinals dataSemiFinals={dataSemiFinals} />

            <div
              className={`relative self-center h-[266px] w-1 bg-[#23556d]`}
            ></div>
            <div className="flex flex-col gap-6 relative top-[154px]">
              <div className="flex center">
                <div className="self-center w-[18px] h-[2px] bg-[#23556d]"></div>
                <Finals dataFinals={dataFinals} />
              </div>
              {/* <div className="flex center">
                <div className=" self-center w-[18px] h-[2px] bg-transparent"></div>
                <ThirdPlace dataThirdPlace={dataThirdPlace} />
              </div> */}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default KnockoutTable;
